// extracted by mini-css-extract-plugin
module.exports = {"block":"Operator_block__38lMO","active":"Operator_active__10tjC"};